import { Trans } from 'react-i18next';
import styled from 'styled-components';

const Tabs = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const Tab = styled.button<{ $active: boolean }>`
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid ${props => props.$active ? 'rgb(254, 167, 0)' : '#3a3a3a'};
  background-color: ${props => props.$active ? 'rgba(254, 167, 0, 0.15)' : 'transparent'};
  color: ${props => props.$active ? 'rgb(254, 167, 0)' : '#8a8a8a'};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: ${props => props.$active ? 'rgb(254, 167, 0)' : '#c9c9c9'};
  }
`;

/**
 * 丸い切り替えタブ。並び順の切り替えなど、選択肢が横に並ぶ場面で使う。
 * ラベルは翻訳キーとして扱う。
 */
function PillTabs<T extends string>(props: {
  value: T,
  options: { value: T, label: string }[],
  onChange(value: T): void,
}) {
  return <Tabs>
    {props.options.map(option => <Tab
      key={option.value}
      $active={option.value === props.value}
      onClick={() => props.onChange(option.value)}>
      <Trans>{option.label}</Trans>
    </Tab>)}
  </Tabs>;
}

export default PillTabs;
